module.exports = "<item-row [row$]=\"row\" [size]=\"'xs'\"></item-row>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/search/search-section/search-section.template.html
// module id = 821
// module chunks = 2